import React from 'react';
import { useActiveBreakpoint } from './hooks/useActiveBreakpoint';
// Import images
import childMentoringImage from '../assets/mentoring-for-children-child-activities-programs-1-384x573.jpg';
import youthMentoringImage from '../assets/youth-mentoring-programs-for-18-years-plus-young-people-1.jpg';

// Children's mentoring options (same as adult options but child-focused)
const childrenMentoringOptions = [
  { id: 1, title: "Mentoring for Child Victims of Bullying" },
  { id: 2, title: "Mentoring for Child Perpetrators of Bullying", note: "* Age-appropriate intervention" },
  { id: 3, title: "Mentoring for Children of Divorced Parents" },
  { id: 4, title: "Mentoring for Children with Behavioral Challenges" },
  { id: 5, title: "Mentoring for Children Away from their Families" },
  { id: 6, title: "Mentoring for Adopted or Foster Children" },
  { id: 7, title: "Mentoring for Children with New Siblings" },
  { id: 8, title: "Mentoring for Children from Mixed Heritage Families" },
  { id: 9, title: "Mentoring for Children in Single Parent Families" },
  { id: 10, title: "Mentoring for Grieving Children" },
  { id: 11, title: "Mentoring for Children who lost a Parent" },
  { id: 12, title: "Mentoring for Children who lost a Sibling" }
];

function Heading1Desktop() {
  return (
    <div className="relative h-auto lg:absolute lg:h-[64px] lg:left-0 lg:top-0 w-full lg:w-[354px] mb-4 lg:mb-0" data-name="Heading 1">
      <h1 className="font-['Inter:Bold',sans-serif] font-bold leading-[32px] not-italic text-[20px] md:text-[24px] text-black tracking-[0.0703px]">
        Mentoring for Children – Child Activities Programs
      </h1>
    </div>
  );
}

function ParagraphDesktop() {
  return (
    <div className="relative h-auto lg:absolute lg:h-[288px] lg:left-0 lg:right-0 lg:top-[116px] mb-4 lg:mb-0" data-name="Paragraph">
      <p className="font-['Inter:Bold',sans-serif] font-bold leading-[28px] text-[20px] text-black tracking-[-0.4492px] mb-4">
        £30.00 – £60.00
      </p>
      <p className="font-['Inter:Regular',sans-serif] font-normal leading-[24px] not-italic text-[16px] text-black tracking-[-0.3125px]">
        The "Mentoring for Children – Child Activities Programs" offers a unique opportunity to nurture your child's growth and development. This program provides personalized guidance and engaging activities designed to build confidence, social skills, and emotional resilience. With expert mentors dedicated to your child's success, this program helps them explore their potential, develop positive habits, and navigate life's challenges with support and encouragement, setting them on a path to a bright future.
      </p>
    </div>
  );
}

function LabelDesktop() {
  return (
    <div className="h-[24px] relative shrink-0 w-full" data-name="Label">
      <p className="absolute font-['Inter:Bold',sans-serif] font-bold leading-[24px] left-0 not-italic text-[16px] text-black text-nowrap top-0 tracking-[-0.3125px] whitespace-pre">Choose An Option:</p>
    </div>
  );
}

function DropdownDesktop() {
  return (
    <div className="h-[46px] relative rounded-[4px] shrink-0 w-full" data-name="Dropdown">
      <div aria-hidden="true" className="absolute border border-[#d1d5dc] border-solid inset-0 pointer-events-none rounded-[4px]" />
      <select className="absolute inset-0 w-full h-full bg-transparent border-none outline-none px-3">
        {childrenMentoringOptions.map((option) => (
          <option key={option.id} value={option.id}>
            {option.title} {option.note || ''}
          </option>
        ))}
      </select>
    </div>
  );
}

function ContainerDesktop1() {
  return (
    <div className="relative lg:absolute content-stretch flex flex-col gap-[8px] h-[78px] items-start lg:left-0 lg:top-[428px] w-full lg:w-[354px] mb-4 lg:mb-0" data-name="Container">
      <LabelDesktop />
      <DropdownDesktop />
    </div>
  );
}

function LabelDesktop1() {
  return (
    <div className="h-[24px] relative shrink-0 w-full" data-name="Label">
      <p className="absolute font-['Inter:Bold',sans-serif] font-bold leading-[24px] left-0 not-italic text-[16px] text-black text-nowrap top-0 tracking-[-0.3125px] whitespace-pre">Choose A Time:</p>
    </div>
  );
}

function DropdownDesktop1() {
  return (
    <div className="h-[46px] relative rounded-[4px] shrink-0 w-full" data-name="Dropdown">
      <div aria-hidden="true" className="absolute border border-[#d1d5dc] border-solid inset-0 pointer-events-none rounded-[4px]" />
      <select className="absolute inset-0 w-full h-full bg-transparent border-none outline-none px-3">
        <option>10:00 AM - 11:00 AM (Child-friendly time)</option>
        <option>2:00 PM - 3:00 PM (After school)</option>
        <option>3:00 PM - 4:00 PM (After school)</option>
        <option>4:00 PM - 5:00 PM (After school)</option>
      </select>
    </div>
  );
}

function ContainerDesktop2() {
  return (
    <div className="relative lg:absolute content-stretch flex flex-col gap-[8px] h-[78px] items-start lg:left-0 lg:top-[522px] w-full lg:w-[354px] mb-4 lg:mb-0" data-name="Container">
      <LabelDesktop1 />
      <DropdownDesktop1 />
    </div>
  );
}

function ButtonDesktop() {
  return (
    <button className="h-[46px] w-[40.781px] bg-transparent border-0 cursor-pointer" data-name="Button">
      <p className="font-['Inter:Regular',sans-serif] font-normal leading-[28px] text-[20px] text-black tracking-[-0.4492px]">-</p>
    </button>
  );
}

function TextDesktop() {
  return (
    <div className="relative shrink-0 size-[40px]" data-name="Text">
      <p className="absolute font-['Inter:Regular',sans-serif] font-normal leading-[24px] left-[50%] text-[16px] text-black text-center top-[8px] tracking-[-0.3125px] translate-x-[-50%]">1</p>
    </div>
  );
}

function ButtonDesktop1() {
  return (
    <button className="basis-0 grow h-[46px] min-h-px min-w-px bg-transparent border-0 cursor-pointer" data-name="Button">
      <p className="font-['Inter:Regular',sans-serif] font-normal leading-[28px] text-[20px] text-black tracking-[-0.4492px]">+</p>
    </button>
  );
}

function ContainerDesktop3() {
  return (
    <div className="relative lg:absolute box-border content-stretch flex h-[48px] items-center lg:left-0 p-px rounded-[4px] lg:top-0 w-[126.812px]" data-name="Container">
      <div aria-hidden="true" className="absolute border border-[#d1d5dc] border-solid inset-0 pointer-events-none rounded-[4px]" />
      <ButtonDesktop />
      <TextDesktop />
      <ButtonDesktop1 />
    </div>
  );
}

function ButtonDesktop2() {
  return (
    <button className="relative lg:absolute bg-black h-[48px] lg:left-[142.81px] rounded-[4px] lg:top-0 w-full lg:w-[131.031px] border-0 cursor-pointer mt-4 lg:mt-0" data-name="Button">
      <p className="font-['Inter:Regular',sans-serif] font-normal leading-[24px] text-[16px] text-white tracking-[-0.3125px]">Add to Cart</p>
    </button>
  );
}

function ContainerDesktop4() {
  return (
    <div className="relative lg:absolute h-auto lg:h-[48px] lg:left-0 lg:top-[624px] w-full lg:w-[354px] mb-4 lg:mb-0 flex flex-col lg:flex-row gap-4 lg:gap-0" data-name="Container">
      <ContainerDesktop3 />
      <ButtonDesktop2 />
    </div>
  );
}

function LinkDesktop() {
  return (
    <button className="bg-transparent border-0 cursor-pointer p-0 text-left">
      <p className="font-['Inter:Regular',sans-serif] font-normal leading-[24px] text-[16px] text-black tracking-[-0.3125px]">Compare</p>
    </button>
  );
}

function LinkDesktop1() {
  return (
    <button className="bg-transparent border-0 cursor-pointer p-0 text-left">
      <p className="font-['Inter:Regular',sans-serif] font-normal leading-[24px] text-[16px] text-black tracking-[-0.3125px]">Add to wishlist</p>
    </button>
  );
}

function ContainerDesktop5() {
  return (
    <div className="relative lg:absolute h-auto lg:h-[24px] lg:left-0 lg:top-[696px] w-full lg:w-[354px] flex flex-col lg:flex-row gap-4 lg:gap-6" data-name="Container">
      <LinkDesktop />
      <LinkDesktop1 />
    </div>
  );
}

function ImageChildMentoringDesktop() {
  return (
    <div className="relative rounded-[10px] shrink-0 w-full lg:w-[587px] h-auto lg:h-[720px] lg:[grid-area:1_/_1]" data-name="Image Child Mentoring">
      <img alt="Child Mentoring Program" className="w-[60%] h-auto lg:h-full object-contain lg:object-cover pointer-events-none rounded-[10px]" src={childMentoringImage} />
    </div>
  );
}

function ContainerDesktop7() {
  return (
    <div className="relative shrink-0 w-full lg:w-[738px] px-4 lg:px-0 lg:[grid-area:1_/_2]" data-name="Container">
      <Heading1Desktop />
      <ParagraphDesktop />
      <ContainerDesktop1 />
      <ContainerDesktop2 />
      <ContainerDesktop4 />
      <ContainerDesktop5 />
    </div>
  );
}

function ContainerDesktop8() {
  return (
    <div className="gap-[32px] grid grid-cols-1 lg:grid-cols-[repeat(2,_minmax(0px,_1fr))] grid-rows-auto lg:grid-rows-[repeat(1,_minmax(0px,_1fr))] h-auto lg:h-[849px] relative shrink-0 w-full px-4 lg:px-0" data-name="Container">
      <ImageChildMentoringDesktop />
      <ContainerDesktop7 />
    </div>
  );
}

function ChildrenMentoringOptionsSection() {
  return (
    <div className="w-full max-w-4xl mx-auto px-4 py-8">
      <div className="mb-8">
        <h2 className="font-['Inter:Extra_Light',sans-serif] font-extralight text-[24px] text-black mb-6">
          Which Mentoring needed
        </h2>
        <div className="space-y-4">
          {childrenMentoringOptions.map((option, index) => (
            <div key={option.id} className="flex items-start gap-2">
              <span className="font-['Inter:Extra_Light',sans-serif] font-extralight text-[20px] text-black">
                {index + 1}.
              </span>
              <div>
                <span className="font-['Inter:Extra_Light',sans-serif] font-extralight text-[20px] text-black">
                  {option.title}
                </span>
                {option.note && (
                  <p className="font-['Inter:Extra_Light',sans-serif] font-extralight text-[16px] text-gray-600 mt-1">
                    {option.note}
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="border-t-4 border-black my-8"></div>

      <div className="mb-8">
        <h3 className="font-['Inter:Extra_Light',sans-serif] font-extralight text-[24px] text-black mb-4">
          Time Of Meeting
        </h3>
        <p className="font-['Inter:Extra_Light',sans-serif] font-extralight text-[20px] text-black">
          One Hour Mandatory Pre-Mentoring Consultation and/or Self-Help Resources., 30 Minutes Optional Consultation with a Mentor.
        </p>
      </div>

      <div className="bg-blue-50 p-6 rounded-lg mt-8">
        <h3 className="font-['Inter:Bold',sans-serif] font-bold text-[18px] text-black mb-4">
          Benefits for Children:
        </h3>
        <ul className="space-y-2">
          <li className="font-['Inter:Regular',sans-serif] text-[16px] text-black">• Build confidence and self-esteem</li>
          <li className="font-['Inter:Regular',sans-serif] text-[16px] text-black">• Develop social and emotional skills</li>
          <li className="font-['Inter:Regular',sans-serif] text-[16px] text-black">• Learn positive coping strategies</li>
          <li className="font-['Inter:Regular',sans-serif] text-[16px] text-black">• Improve communication skills</li>
          <li className="font-['Inter:Regular',sans-serif] text-[16px] text-black">• Build resilience and emotional intelligence</li>
        </ul>
      </div>
    </div>
  );
}

function RelatedServicesSection() {
  return (
    <div className="w-full max-w-4xl mx-auto px-4 py-8">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
        <div className="aspect-[384/576] relative">
          <img 
            alt="Youth Mentoring Programs for 18 Years Plus Young People" 
            className="absolute inset-0 max-w-none object-50%-50% object-cover pointer-events-none size-full rounded-lg" 
            src={youthMentoringImage} 
          />
        </div>
        <div className="text-center space-y-4">
          <p className="font-['Inter:Bold',sans-serif] font-bold text-[20px] text-black">
            Youth Mentoring Programs for 18 Years Plus Young People
          </p>
          <a 
            href="https://discountshop.healthcity.org.uk/product-category/mentoring-network/"
            className="block font-['Inter:Extra_Light',sans-serif] font-extralight text-[20px] text-black hover:text-blue-600 transition-colors"
          >
            Mentoring Network
          </a>
          <p className="font-['Inter:Bold',sans-serif] font-bold text-[20px] text-black">
            £30.00 – £60.00
          </p>
        </div>
      </div>
    </div>
  );
}

// Export single component with responsive layout
export default function ChildrenMentoring() {
  return (
    <div className="bg-white min-h-screen">
      <div className="max-w-7xl mx-auto px-4 py-8">
        <ContainerDesktop8 />
        <ChildrenMentoringOptionsSection />
        <RelatedServicesSection />
      </div>
    </div>
  );
}